import React from "react";

export const SoundOn = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <rect
        x="0.47803"
        y="6.87249"
        width="8.43337"
        height="6.29588"
        rx="0.97159"
      />
      <path d="M2.64038,8.67133a1.81608,1.81608,0,0,0,0,2.69819l4.81371,4.4624c.80042.742,1.45531.47467,1.45531-.59407V4.803c0-1.06875-.65489-1.33608-1.45531-.59408Z" />
      <path d="M11.35145,12.7647a.73846.73846,0,0,1-.40347-1.35733,1.67033,1.67033,0,0,0-.01241-2.811.7384.7384,0,1,1,.79465-1.24477,3.14707,3.14707,0,0,1,.02334,5.29344A.73482.73482,0,0,1,11.35145,12.7647Z" />
      <path d="M13.03776,15.34749a.73846.73846,0,0,1-.4043-1.3568,4.75576,4.75576,0,0,0-.01538-7.97978.73842.73842,0,0,1,.80247-1.2398,6.23259,6.23259,0,0,1,.02016,10.45622A.735.735,0,0,1,13.03776,15.34749Z" />
      <path d="M14.8155,18.07036a.73846.73846,0,0,1-.40453-1.35665,8.00777,8.00777,0,0,0-.01629-13.42642A.73842.73842,0,0,1,15.19943,2.049a9.48457,9.48457,0,0,1,.01924,15.90107A.7349.7349,0,0,1,14.8155,18.07036Z" />
      <path d="M8.873,29.97757V28.01251c0-.02-.00081-.03974-.002-.05942V24.97145c0-1.06875-.65489-1.33608-1.45531-.59408L4.76718,26.83254Z" />
      <path d="M2.5671,27.04093H1.41117a.97444.97444,0,0,0-.97158.97158v4.35271a.97444.97444,0,0,0,.97158.97159H4.54239l2.87325,2.66355c.80042.742,1.45531.47467,1.45531-.59407V32.42465c.0012-.01968.002-.03946.002-.05943v-.494Z" />
    </svg>
  );
};
